import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateScenarioGrant } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreateScenarioGrant = () => {
  const { mutate: createScenarioGrant, isPending } = useAppMutation(
    [QueryKey.CREATE_SCENARIO_GRANT],
    {
      mutationFn: ({ scenarioId, data }: { data: CreateScenarioGrant; scenarioId: string }) =>
        ApiService.post(
          { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'grants'] },
          { body: data },
        ),
    },
  );
  return { createScenarioGrant, isPending };
};
